export default __webpack_public_path__ + "static/media/historyIcon.45730b34.svg";